import { useEffect, useRef } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { Navigate, useSearchParams } from "react-router-dom";

import { SplashScreen } from "@/shell/SplashScreen";
import {
  buildLoginWithRedirectOptions,
  readInvitationParams,
} from "./invitationParams";

/**
 * Dedicated `/login` entry — Auth0 Application Login URI target.
 *
 * Forwards invitation query params when present; otherwise starts Universal
 * Login without an `organization` parameter so Auth0's org prompt handles
 * tenant selection (Prompt for Organization in the SPA settings).
 */
export function LoginPage() {
  const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0();
  const [searchParams] = useSearchParams();
  const redirectedRef = useRef(false);

  useEffect(() => {
    if (isLoading || isAuthenticated || redirectedRef.current) return;
    redirectedRef.current = true;
    const search = searchParams.size ? `?${searchParams.toString()}` : "";
    const params = readInvitationParams(search);
    const returnTo = searchParams.get("returnTo");
    void loginWithRedirect(
      buildLoginWithRedirectOptions(
        params,
        returnTo && returnTo.startsWith("/") ? returnTo : "/",
      ),
    );
  }, [isAuthenticated, isLoading, loginWithRedirect, searchParams]);

  if (isAuthenticated) {
    const returnTo = searchParams.get("returnTo");
    return (
      <Navigate
        to={returnTo && returnTo.startsWith("/") ? returnTo : "/"}
        replace
      />
    );
  }

  return <SplashScreen />;
}
